var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFaq = function SvgFaq(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10808_178991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6611 19.7113C15.3012 20.5351 13.7059 21.0093 12 21.0093C7.0243 21.0093 2.99072 16.9757 2.99072 12C2.99072 7.02435 7.0243 2.99081 12 2.99081C16.9756 2.99081 21.0092 7.02435 21.0092 12C21.0092 13.8503 20.4387 15.5702 19.4822 17.0009",
    stroke: "#919191",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.07031 9.61599C9.07031 8 10.3803 6.68997 11.9963 6.68997C13.6123 6.68997 14.9223 8 14.9223 9.61599H14.923C14.9233 10.8251 14.1904 11.8631 13.1446 12.3096C12.4432 12.609 11.9963 13.3274 11.9963 14.09",
    stroke: "#919191",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10808_178991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.5,
    height: 21.5,
    fill: "currentColor",
    transform: "translate(1.25 1.25)"
  })))));
};
export default SvgFaq;